<template>
  <div class="content-page mobile-app">
    <div class="mian-page">
      <div class="title-page">{{ ruleForm.moduleCode == '3'? '我要撤回' : '我要查询' }}</div>
      <div class="backgroundBox">
        <div class="main-contentBox">
          <div class = "re-contentBox">
            <div class="textBox">
              <el-form :model="ruleForm" :label-position="labelPosition"  :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm search-items ">
                <el-form-item prop="applicantCategory">
                  <span slot="label">
                    查询类型
                    <el-tooltip v-if="ruleForm.applicantCategory == 3" class="item" effect="dark" content="于2023年5月31日前提交网上申请并获取编号的查询（编号一般是以“fy”或者“FYSQ“开头）" placement="bottom">
                      <i class="el-icon-warning" style="color:#5A9CFF;margin-top: 0;margin-left: 5px"></i>
                    </el-tooltip>
                  </span>

                  <el-select v-model="ruleForm.applicantCategory" style="width:100%">
                    <el-option value="1" key="1" label="个人查询"></el-option>
                    <el-option value="2" key="2" label="法人/组织查询"></el-option>
                    <!-- <el-option value="3" key="3" label="编号查询"></el-option> -->
                  </el-select>
                </el-form-item>
                <el-form-item label="身份证号" v-if="ruleForm.applicantCategory == 1" prop="identificationCard" disabled>
                  <el-input :disabled="userInfo.idcard" :placeholder="`请输入身份证号码`" v-model.trim="ruleForm.identificationCard"  maxlength="18"></el-input>
                </el-form-item>
                <el-form-item  v-if="ruleForm.applicantCategory == 2" label="组织名称" prop="loginName" disabled>
                  <el-input :placeholder="`请输入组织名称`" v-model.trim="ruleForm.loginName"  maxlength="18"></el-input>
                </el-form-item>
                <el-form-item v-if="ruleForm.applicantCategory == 1 || ruleForm.applicantCategory == 2" :label="`${ ruleForm.applicantCategory == 2 ? '联系人' : '' }手机号码`" prop="phone">
                  <el-input :disabled="userInfo.mobile" placeholder="请输入手机号码" v-model.trim="ruleForm.phone"  maxlength="20">
                    <template slot="append">
                    <div v-no-more-div v-if="!isDisabled && (ruleForm.applicantCategory == 1 || ruleForm.applicantCategory == 2)">
                      <div v-no-more-div @click="getNumberCode" class="codebtn"> {{content}} </div>
                    </div>
                    <div  v-if="isDisabled && (ruleForm.applicantCategory == 1 || ruleForm.applicantCategory == 2)">
                      <div class="codebtn-gary"> {{content}} </div>
                    </div>
                  </template>
                  </el-input>
                </el-form-item>
                <el-form-item v-if="ruleForm.applicantCategory == 3" label="申请编号" prop="number">
                  <el-input placeholder="请输入申请编号" v-model.trim="ruleForm.number"  maxlength="20"></el-input>
                </el-form-item>
                <el-form-item v-if="ruleForm.applicantCategory == 3" label="密码" prop="password">
                  <el-input type="password" placeholder="请输入密码" v-model.trim="ruleForm.password" autocomplete="new-password" maxlength="10"></el-input>
                </el-form-item>
                <el-form-item  v-if="ruleForm.applicantCategory == 1 || ruleForm.applicantCategory == 2" label="手机验证码" prop="verificationCode" class="phone col1-2">
                  <el-input placeholder="请输入验证码" v-model.trim="ruleForm.verificationCode" maxlength="8"></el-input>
                </el-form-item>
              </el-form>

              <div class="tip" v-if="ruleForm.applicantCategory == 1 || ruleForm.applicantCategory == 2">1.请核对所输入的手机号码是否是行政复议申请书中所记载的号码。</div>
              <div class="tip" v-if="ruleForm.applicantCategory == 1 || ruleForm.applicantCategory == 2">2.如无法查询到申请信息，请与相关复议机构联系。</div>

            </div>

          </div>
          <div class="btnLists">

            <div v-no-more-div class="border-btn" @click="$router.push('/m-codeSearch')" >返回上一页</div>
            <div v-no-more-div class="primary-btn" @click="submitForm('ruleForm')"> 查询 </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ocrIdCardCheck, uuid } from '@/utils';
import Api from '@api/api';
import { addAntiReplayParams } from '@/utils/antireplay';
const moduleCodeSwitch = () => {
  switch (localStorage.getItem('oprate')) {
    case 'apply':
      return '1';
      break;
    case 'search':
      return '2';
      break;
    case 'revokeApply':
      return '3';
      break;
  }
};
export default {
  data () {
    var validatePhone = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(this.ruleForm.phone)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    };
    var validateName = (rule, value, callback) => {
      if (/\s+/g.test(this.ruleForm.loginName) || value === '') {
        callback(new Error('请输入正确的' + this.nameText + '名称'));
      } else {
        callback();
      }
    };

    var validateIdCard = (rule, value, callback) => {
      if (!/^[1-9]\d{5}(?:18|19|20|21|22)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/.test(this.ruleForm.identificationCard) || value === '') {
        callback(new Error('请输入正确的证件号码'));
      } else {
        callback();
      }
    };
    return {
      nameText: '申请人',
      isDisabled: false, // 控制按钮是否可以点击
      content: '获取验证码', // 发送验证码按钮的初始显示文字
      timer: null, // 定时器
      count: null,
      userInfo: {},
      caseOrderNo: uuid(), // 生成的案件流水号
      oprate: localStorage.getItem('oprate'),
      identificationApplicant: uuid(), // 申请人id 都uuid生成
      ruleForm: {
        applicantCategory: '1',
        fileListJpg: [],
        identificationCard: '',
        fileListJpg2: [],
        moduleCode: moduleCodeSwitch(),
        identificationType: '1001001',
        loginName: '',
        phone: '',
        verificationCode: null,
        id: '' // 验证码失效时需要传
      },
      rules: {
        loginName: [
          { required: true, validator: validateName, trigger: 'blur' }
        ],
        applicantCategory: [
          { required: true, message: '请选择申请人类型', trigger: 'blur' }
        ],
        identificationCard: [
          { required: true, validator: validateIdCard, trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        verificationCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        number: [
          { required: true, message: '请输入查询编号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入查询密码', trigger: 'blur' }
        ]
      },
      labelPosition: 'left'
    };
  },
  watch: {
    'ruleForm.applicantCategory': function (val) {
      console.log(val);
      if (val == 1) {
        this.nameText = '申请人';
      } else {
        this.nameText = '联系人';
      }
    }
  },
  created () {

  },
  mounted () {
    const userInfo = localStorage.getItem('userInfo');
    console.log(userInfo);
    if (userInfo) {
      this.userInfo = JSON.parse(userInfo);
      this.ruleForm.phone = this.userInfo.mobile;
      this.ruleForm.loginName = this.userInfo.qyname || this.userInfo.name;
      this.ruleForm.identificationCard = this.userInfo.idcard;
    }
    if (document.body.clientWidth <= 750) {
      this.labelPosition = 'top';
    } else {
      this.labelPosition = 'left';
    }
    window.onresize = () => {
      return (() => {
        if (document.body.clientWidth <= 750) {
          this.labelPosition = 'top';
        } else {
          this.labelPosition = 'left';
        }
      })();
    };
  },
  methods: {
    handleRemoveGh () {
      this.ruleForm.fileListJpg = [];
    },
    handleRemove () {
      this.ruleForm.fileListJpg2 = [];
    },
    // 上传文件之前的钩子
    beforeUpload (file) {
      const isLt100MB = file.size / 1024 / 1024 < 100;
      const a = file.name;
      const b = [
        '.jpg',
        '.gif',
        '.png',
        '.jpeg'
      ];
      const isType = b.includes(a.slice(a.lastIndexOf('.')).toLowerCase());
      if (!isLt100MB) {
        if (document.getElementsByClassName('el-message').length > 0) {
          return false;
        }
        this.$toast('上传文件大小不能超过 100MB!');
        return false;
      }
      if (!isType) {
        if (document.getElementsByClassName('el-message').length > 0) {
          return false;
        }
        this.$toast('上传文件格式必须为1.jpg 2.jpeg 9.png');
        return false;
      }
      if (!this.ruleForm.identificationCard) {
        this.$toast('请先输入身份证号！');
        return false;
      }
    },
    // 获取验证码
    getNumberCode () {
      // 校验身份证号
      // 如果不是法人则校验身份证
      if (this.ruleForm.applicantCategory == '1') {
        // 校验身份证
        if (!/^[1-9]\d{5}(?:18|19|20|21|22)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/.test(this.ruleForm.identificationCard)) {
          this.$toast('请输入正确的证件号码');
          return;
        }
      } else {
        // 校验是否输入组织名称
        if (!this.ruleForm.loginName) {
          this.$toast('请输入法人/组织名称');
          return;
        }
      }
      // 校验手机号
      if (!/^1[3456789]\d{9}$/.test(this.ruleForm.phone)) {
        this.$toast('请输入正确的手机号码');
        return;
      }

      this.isDisabled = false;
      
      // 准备请求参数
      const requestParams = {
        phone: this.ruleForm.phone,
        identificationCard: this.ruleForm.identificationCard,
        id: this.ruleForm.id,
        loginText: this.ruleForm.applicantCategory == '1' ? '' : this.ruleForm.loginName
      };
      
      // 添加防重放攻击参数（签名、nonce、timestamp）
      const secureParams = addAntiReplayParams(requestParams);
      
      Api.getcode(secureParams).then(
        (res) => {
          this.isDisabled = false;
          this.ruleForm.id = res.data.data;
          if (res.data.code == 0 && res.data.data) {
            this.$toast('验证码已发送');
            const TIME_COUNT = 60;
            this.count = TIME_COUNT;
            this.timer = window.setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.isDisabled = true;
                this.count--;
                this.content = this.count + 's后重新获取';
              } else {
                this.isDisabled = false;
                this.content = '获取验证码';
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        }
      );
    },
    login () {
      // 人口库校验
      const applicantInfoListCal = [];
      applicantInfoListCal.push({
        name: this.ruleForm.loginName,
        id: this.ruleForm.identificationCard
      });
      const param = [...applicantInfoListCal];
      localStorage.setItem('sessionId', uuid());
      Api.saveLoginInfo({
        ...this.ruleForm,
        loginText: this.ruleForm.applicantCategory == '1' ? '' : this.ruleForm.loginName,
        isToWithdraw: this.oprate == 'revokeApply' ? 1 : null,
        moduleCode: moduleCodeSwitch()
      }).then((res) => {
        if (res.data.code === '0') {
          localStorage.setItem('applicantCategory', this.ruleForm.applicantCategory); // 存储申请人类型
          localStorage.setItem('applicantInfo', JSON.stringify(this.ruleForm));
          this.$router.push({
            name: 'Mcaselist',
            query: {
              name: localStorage.getItem('oprate'),
              phone: this.ruleForm.phone,
              searchType: res.data.data,
              loginName: this.ruleForm.loginName,
              applicantCategory: this.ruleForm.applicantCategory,
              identificationCard: this.ruleForm.identificationCard
            }
          });
        }
      });
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.applicantCategory == '3') {
            // 编号查询
            Api.oldDetail({
              number: this.ruleForm.number,
              password: this.ruleForm.password
            }).then((res) => {
              if (res.data.code === '0') {
                this.$toast({
                  type: 'text',
                  message: '查询成功',
                  onClose: () => {
                    this.$cookie.set('LoginPass', this.ruleForm.password);
                    this.$router.push({
                      name: 'MoldDetailCase',
                      query: {
                        number: this.ruleForm.number
                      }
                    });
                  }
                });
              }
            });
          } else {
          // 校验手机验证码
            Api.checkCerificationCode({
              loginName: this.ruleForm.loginName,
              identificationCard: this.ruleForm.identificationCard,
              phone: this.ruleForm.phone,
              verificationCode: this.ruleForm.verificationCode,
              id: this.ruleForm.id, // 验证码失效时需要传
              loginText: this.ruleForm.applicantCategory == '1' ? '' : this.ruleForm.loginName
            }).then(({ data }) => {
              if (data.code == 0) {
                this.login();
              }
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.main-contentBox{
  padding: 16px;
  height: auto;
  .re-contentBox{
    overflow: auto;
    min-height: 380px;
    background: rgba(255, 255, 255, 0.05);
    box-shadow: 2px 6px 10px 0px rgba(128, 126, 189, 0.24);
    border-radius: 8px;
    backdrop-filter: blur(20px);
    display: flex;
    align-items: center;
    justify-content: center;
    .textBox{
      width: 100%;
      .tiptext{
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #999999;
        line-height: 37px;
        margin-left: 5px;
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .main-contentBox {
    padding: 16px;
  }
  .tiptext {
    font-size: 12px !important;
  }
  .el-input {
    font-size: 12px !important;
  }
}
::v-deep .el-input-group__append, .el-input-group__prepend {
      background: linear-gradient(
90deg
, #e4c995 0%, #b9916a 100%);
    }
@media screen and (max-width: 750px) {
  .main-contentBox {
    padding: 16px;
  }

  .main-contentBox .re-contentBox{
    backdrop-filter:none;
  }
  .re-contentBox {
    padding: 16px;
    .el-form-item__content {
      margin-bottom: 0 !important;
      margin-left: 10px !important;
    }
    ::v-deep .el-form-item__label {
      padding: 0px !important;
    }
    .flexEnd {
      display: flex;
      align-items: center;
    }
    .pt10 {
      padding-top: 10px;
    }
    .pt15 {
      padding-top: 15px;
    }
  }
}

.upload-identificationFile{
  .upload-identiFile{
    display: flex;
    background-color: rgb(223,240,253);
    border-radius: 3px;
    height: 40px;
    width: 100%;
    align-items: center;
    .identiFile-btn{
      background-color:#5A9CFF;
      height: 24px;
      width :100%;
      line-height: 23px;
      color: white;
      border-radius: 3px;
      font-size: 12px;
      margin-left: 3px;
    }
    ::v-deep .el-upload-list {
      margin-left: 5px;
      width:70%;
      overflow :hidden;
      white-space: nowrap;
      text-overflow:ellipsis
    }
    ::v-deep .el-upload-list__item:first-child{
      margin-top: 0px;
    }
    ::v-deep .el-upload--text {
      width: 100%;
    }
  }
}
.tip {
  font-size: 14px;
  color:red;
  line-height: 22px;
  margin-top: 10px;
}
@media screen and (max-width: 500px) {
  .main-contentBox {
    padding: 16px;
  }
  .re-contentBox {
    .text-width {
      width: 100% !important;
      padding-top: 0 !important;
    }
    .el-form-item {
      width:100%!important;
      margin-bottom: 0 !important;
    }
    ::v-deep .el-form-item__error {
      position: static !important;
    }
    .pt10 {
      padding-top: 36px !important;
    }
  }
}
@media screen and (max-width: 300px) {
  .el-form-item {
    width: 100%;
  }
  .re-contentBox .pt10 {
    padding-top: 10px !important;
  }
}
.codebtn{
      font-size: 14px;
      color: #FFFFFF;
      cursor: pointer;
    }
    .codebtn-gary{
     cursor: pointer;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #FFFFFF;
      cursor: not-allowed;
    }
</style>
